import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AnalyticsChartComponent } from '../../analytics-chart/analytics-chart.component';

type GroupByType = 'day' | 'week' | 'month' | 'year';

@Component({
  selector: 'app-smart-energy-view',
  templateUrl: './smart-energy-view.component.html',
  styleUrl: './smart-energy-view.component.scss'
})
export class SmartEnergyView implements OnInit, OnChanges {
  @Input() filters?: Record<string, any[]> | null = { groupBy: ['year'] };
  @ViewChild('smartEnergyChart') smartEnergyChart?: AnalyticsChartComponent;

  selectedGroup: GroupByType = 'year';
  transformedData: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters']) {
      this.updateFilterReferences();
    }
  }

  ngOnInit(): void {
    this.updateFilterReferences();
  }

  updateFilterReferences(): void {
    this.filters = this.mergeFilters({ groupBy: [this.selectedGroup] });
  }

  mergeFilters(additionalFilters: Record<string, any[]>): Record<string, any[]> {
    return { ...(this.filters ?? {}), ...additionalFilters };
  }

  toggleKWHPlusDataset(): void {
    this.smartEnergyChart?.toggleDataset(0);
  }

  toggleKWHMinusDataset(): void {
    this.smartEnergyChart?.toggleDataset(1);
  }

  isKWHPlusVisible(): boolean {
    return this.smartEnergyChart?.isDatasetVisible(0) ?? true;
  }

  isKWHMinusVisible(): boolean {
    return this.smartEnergyChart?.isDatasetVisible(1) ?? true;
  }

  onGroupChange(value: string): void {
    if (value === 'day' || value === 'week' || value === 'month' || value === 'year') {
      this.selectedGroup = value;
      this.updateFilterReferences();
    }
  }

  transformSmartEnergyData(rawData: any): any[] {
    if (!rawData?.rows || !Array.isArray(rawData.rows)) {
      return [];
    }

    return [
      {
        rows: rawData.rows.map((row: any) => ({
          ts: row[this.selectedGroup] || row.day || row.month || row.year,
          value: parseFloat(row.total_kwh_plus) || 0
        }))
      },
      {
        rows: rawData.rows.map((row: any) => ({
          ts: row[this.selectedGroup] || row.day || row.month || row.year,
          value: parseFloat(row.total_kwh_minus) || 0
        }))
      }
    ];
  }
}
